var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full bg-gray-200 rounded-full h-1 dark:bg-gray-700"},[_c('div',{staticClass:"h-1 rounded bg-green-600",style:({ width: _vm.progressBarWidth })})])}
var staticRenderFns = []

export { render, staticRenderFns }